import faqNo from './faq/no';

const noTranslations = {
    accountAccess: {
        emailLabel: 'E-post',
        phoneLabel: 'Mobilnummer',
        phoneHint: 'Norsk nummer, eller ta med landskoden',
        useEmail: 'Bruk e-post i stedet',
        usePhone: 'Bruk mobilnummer i stedet',
        sendCode: 'Send kode',
        codeLabel: 'Sekssifret kode',
        confirmCode: 'Bekreft kode',
        codeSentTo:
            'Vi har sendt en sekssifret kode til {{contact}}. Den er gyldig i {{duration}}.',
        duration: {
            minutes: '{{count}} min',
            hours: '{{count}} timer',
            days: '{{count}} dager',
        },
        deliveryFailed:
            'Vi fikk ikke sendt koden til {{contact}}. Send en ny kode, eller bruk en annen e-post eller et annet mobilnummer.',
        resend: 'Send ny kode',
        resendIn: 'Send ny kode om {{time}}',
        useDifferentContact: 'Bruk en annen e-post eller et annet mobilnummer',
        passwordRules:
            'Bruk minst 8 tegn, med en stor bokstav, en liten bokstav og et tall.',
        activation: {
            codeExpiredResent:
                'Invitasjonskoden hadde utløpt, så vi har sendt deg en ny.',
            title: 'Aktiver invitasjonen',
            description:
                'Bruk e-posten eller mobilnummeret omsorgsstedet inviterte deg med. Du får en kode, og så velger du ditt eget passord.',
            submit: 'Aktiver kontoen',
            steps: {
                contact: '1. Hvor fikk du invitasjonen?',
                code: '2. Skriv inn koden',
                password: '3. Velg passord',
            },
        },
        contacts: {
            notAdded: 'Ikke lagt til',
            addEmail: 'Legg til e-post',
            addPhone: 'Legg til mobilnummer',
            changeEmail: 'Endre e-post',
            changePhone: 'Endre mobilnummer',
            confirmEmail: 'Bekreft e-post',
            confirmPhone: 'Bekreft mobilnummer',
            confirmAction: 'Bekreft',
            confirmNote:
                'Vi sender en kode for å bekrefte den. Etterpå kan du bruke den til å logge inn og tilbakestille passordet.',
            add: 'Legg til',
            change: 'Endre',
            newEmail: 'Ny e-post',
            newPhone: 'Nytt mobilnummer',
            keepsWorking:
                'Du kan fortsatt bruke {{contact}} til den nye er bekreftet.',
            confirm: 'Bekreft og lagre',
            saved: 'Lagret. Du kan nå logge inn med {{contact}}.',
        },
        staffContacts: {
            pendingNote: 'Invitasjonen er ikke aktivert ennå.',
        },
        invitation: {
            sendEmail: 'Send på e-post',
            sendSms: 'Send på SMS',
            sent: 'Invitasjonen er sendt til {{contact}}.',
            sendBy: 'Send invitasjonen på',
            byEmail: 'E-post',
            bySms: 'SMS',
            contactRequired: 'Skriv inn en e-post eller et norsk mobilnummer.',
        },
        errors: {
            CONTACT_CONFIRMED:
                'Denne kontaktinformasjonen er bekreftet. Bare personen selv kan endre den, i profilen sin.',
            LAST_INVITATION_CONTACT:
                'En invitasjon trenger en e-post eller et mobilnummer. Legg til den andre før du fjerner denne.',
            rateLimited:
                'Det er sendt for mange koder. Prøv igjen om {{duration}}.',
            CODE_INVALID: 'Koden er feil. Sjekk den, eller send en ny kode.',
            CODE_EXPIRED: 'Koden har utløpt. Send en ny kode.',
            CONTACT_EXISTS:
                'Denne e-posten eller dette mobilnummeret brukes allerede av en annen konto.',
            CONTACT_NOT_VERIFIED:
                'Denne e-posten eller dette mobilnummeret er ikke bekreftet ennå. Logg inn med den du aktiverte kontoen med, og bekreft den under Min profil.',
            CONTACT_NOT_FOUND:
                'Vi fant ingen invitasjon for dette. Sjekk med omsorgsstedet at de har riktig kontaktinformasjon.',
            ACCOUNT_ACTIVE:
                'Kontoen er allerede aktiv. Logg inn, eller tilbakestill passordet.',
            SIGN_IN_REQUIRED:
                'Kontoen din er klar. Logg inn med det nye passordet.',
            SESSION_EXPIRED: 'Dette tok for lang tid. Start på nytt.',
            ACTIVATION_REQUIRED: 'Kontoen er ikke aktivert ennå.',
        },
    },
    monthPeriod: {
        previous: 'Forrige måned',
        next: 'Neste måned',
        choose: 'Velg måned',
    },
    supportMode: {
        title: 'Supportmodus · {{organization}}',
        readOnly: 'Skrivebeskyttet. Meldinger markeres ikke som lest.',
        exit: 'Avslutt',
        exiting: 'Avslutter…',
    },
    account: {
        loggedIn: 'Innlogget',
        profile: 'Profil',
        faq: 'FAQ',
        logout: 'Logg ut',
        languageLabel: 'Språk',
    },
    onboarding: {
        openGuide: 'Åpne brukerveiledning',
        roles: {
            organization: [
                {
                    id: '1',
                    title: 'Velkommen til Mundu!',
                    description:
                        'Hei, {{username}}! Du er registrert som Superbruker for {{organizationName}} i Mundu. I denne veiledningen får du informasjon om hvordan du kan bidra til at {{organizationName}} kommer best mulig i gang, samt et raskt overblikk over mulighetene du har i Mundu.',
                },
                {
                    id: '2',
                    title: 'Superbruker',
                    description:
                        'Superbrukerrollen innebærer at du har det overordnede administrative ansvaret for bruken av Mundu i {{organizationName}}. Du kan styre tilganger, og opprette eller slette Brukere, Ansatte og Pårørende.',
                },
                {
                    id: '3',
                    title: 'Opprett Brukere',
                    description:
                        'Opprett Brukere slik at du har noen å lage video til. Brukere kan logge inn på nettbrett eller mobil for å motta og spille av videoene du lager.',
                },
                {
                    id: '4',
                    title: 'Inviter pårørende',
                    description:
                        'Inviter brukerens pårørende slik at de kan dele bilder du kan bruke i videoene.',
                },
                {
                    id: '5',
                    title: 'Last opp bilder',
                    description:
                        'Du kan også selv laste opp bilder på vegne av Pårørende for alle Brukere i {{organizationName}}. Bildene blir tilgjengelige når du lager videoer.',
                },
                {
                    id: '6',
                    title: 'Kartlegg den musikalske livshistorien',
                    description:
                        'Utforsk musikkbiblioteket og kartlegg sanger og artister som har fulgt brukeren gjennom livet. Et godt forarbeid gjør det enklere å velge betydningsfull musikk senere.',
                },
                {
                    id: '7',
                    title: 'Lag video',
                    description:
                        'Sett sammen en video med bilder fra Pårørende og musikk fra biblioteket. Når du er fornøyd, kan du sende videoen til brukerens nettbrett.',
                },
                {
                    id: '8',
                    title: 'Mundu finnes også på mobil!',
                    description:
                        'Ønsker du å skanne fysiske bilder eller dele direkte fra mobil eller nettbrett? Last ned Mundu-appen og bruk QR-koden for å finne den i App Store eller Google Play.',
                    type: 'qr',
                },
            ],
            creator: [
                {
                    id: '1',
                    title: 'Velkommen til Mundu!',
                    description:
                        'Hei, {{username}}! Du er registrert som Ansatt for {{organizationName}} i Mundu. Denne veiledningen hjelper deg med å komme i gang.',
                },
                {
                    id: '2',
                    title: 'Ansatt',
                    description:
                        'Som Ansatt kan du opprette Brukere for {{organizationName}}, invitere Pårørende, lage videoer og laste opp bilder til Brukere du følger.',
                },
                {
                    id: '3',
                    title: 'Opprett Brukere',
                    description:
                        'Opprett Brukere slik at du har noen å lage video til. Brukere kan logge inn på nettbrett eller mobil for å motta videoene.',
                },
                {
                    id: '4',
                    title: 'Inviter pårørende',
                    description:
                        'Inviter brukerens pårørende slik at de kan dele bilder du kan bruke i videoene.',
                },
                {
                    id: '5',
                    title: 'Last opp bilder',
                    description:
                        'Du kan selv laste opp bilder på vegne av Pårørende for Brukere du følger. Bildene blir tilgjengelige i videoprosessen.',
                },
                {
                    id: '6',
                    title: 'Kartlegg den musikalske livshistorien',
                    description:
                        'Utforsk musikkbiblioteket og noter deg sangene som betyr mest for brukeren. De blir synlige når du senere lager video.',
                },
                {
                    id: '7',
                    title: 'Lag video',
                    description:
                        'Kombiner bilder og musikk for å lage en personlig video, og send den til brukerens nettbrett når du er klar.',
                },
                {
                    id: '8',
                    title: 'Mundu finnes også på mobil!',
                    description:
                        'Last ned Mundu-appen for å skanne fysiske bilder eller dele fra mobil og nettbrett via QR-koden.',
                    type: 'qr',
                },
            ],
            nextOfKin: [
                {
                    id: '1',
                    title: 'Velkommen til Mundu på web!',
                    description:
                        'Hei, {{username}}! {{organizationName}} har registrert deg som pårørende for {{consumerName}}. Denne veiledningen viser deg hvordan du kommer i gang.',
                },
                {
                    id: '2',
                    title: 'Pårørende',
                    description:
                        'Som pårørende kan du dele bilder med {{organizationName}}. Helsepersonell bruker bildene til å lage personlige videoer for {{consumerName}}.',
                },
                {
                    id: '3',
                    title: 'Legg til bilder',
                    description:
                        'Trykk på «Last opp bilder»-knappen for å starte. Legg bilder i utvalget via «Legg til bilder» eller ved å dra filene direkte inn i området.',
                },
                {
                    id: '5',
                    title: 'Legg til en bildetekst',
                    description:
                        'En kort og tydelig bildetekst gjør det enklere for ansatte i {{organizationName}} å lage meningsfulle videoer. Tekstene er kun synlige for helsepersonell.',
                },
                {
                    id: '6',
                    title: 'Last opp i skyen',
                    description:
                        'Når du er fornøyd med utvalget, bekrefter du samtykke i sidepanelet og laster opp. Ansatten til {{consumerName}} får beskjed når bildene er klare.',
                    type: 'cloud',
                },
                {
                    id: '7',
                    title: 'Mundu på mobil',
                    description:
                        'Last ned Mundu-appen for å skanne fysiske bilder eller dele direkte fra mobil og nettbrett via QR-koden.',
                    type: 'qr',
                },
            ],
            default: [
                {
                    id: '1',
                    title: 'Velkommen til Mundu på web!',
                    description: 'Trykk enter for å komme i gang',
                },
            ],
        },
    },
    search: {
        musicPlaceholder: 'Søk etter musikk',
        genericPlaceholder: 'Søk',
    },
    common: {
        accountStatusFilters: {
            title: 'Kontostatus',
            all: 'Alle',
            active: 'Aktive',
            invited: 'Invitert',
        },
        cancel: 'Avbryt',
        close: 'Lukk',
        edit: 'Rediger',
        search: 'Søk',
        addRemove: 'Legg til / fjern',
        save: 'Lagre',
        confirm: 'Bekreft',
        loading: 'Laster…',
        upload: 'Last opp',
        remove: 'Fjern',
        delete: 'Slett',
        confirmDelete: "Skriv inn '{{value}}' for å slette",
        name: 'Navn',
        phone: 'Telefon',
        email: 'E-post',
        actions: 'Handlinger',
        username: 'Brukernavn',
        group: 'Gruppe',
    },
    browseMusic: {
        favorites: {
            title: 'Musikalsk identitet',
            importance: 'Betydning',
            likesSinging: 'Liker å synge',
        },
        selection: {
            instructions: {
                playlist:
                    'Klikk på «Velg»-knappen for å legge til en sang fra spillelisten',
                search: 'Klikk på et albumcover for å legge til sang fra søkeresultatet',
                release:
                    'Klikk på «Velg»-knappen for å legge til en sang fra utgivelsen',
                artist: 'Klikk på «Velg»-knappen for å legge til en sang av artisten',
            },
            title: 'Valgte sanger',
            empty: 'Seleksjonen er tom...',
            totalDuration: 'Total spilletid:',
            addButton: 'Legg til',
            addSuffix: 'sanger',
            cancel: 'Avbryt og gå tilbake',
        },
        search: {
            tracks: 'Sanger',
            artists: 'Artister',
            albums: 'Album',
            moreSongsPlaceholder: 'Søk etter flere sanger',
            noResults: {
                prefix: 'Fant ingen søkeresultater for ',
                hint: 'Sjekk at søket er korrekt stavet eller benytt færre/andre søkeord.',
                followUp:
                    'Savner du en spesifikk artist, utgivelse eller låt? Mundu-katalogen utvides stadig, og ny musikk blir tilgjengelig i søket når den legges til.',
            },
        },
        playlist: {
            empty: 'Spillelisten er tom. Bruk søkefeltet nedenfor for å finne sanger å legge til.',
        },
        nav: {
            library: 'Bibliotek',
            favorites: 'Favoritter',
        },
        common: {
            loadMore: 'Vis flere',
        },
    },
    alerts: {
        successRedirect: 'Klikk <link>her</link> for å lukke vinduet.',
    },
    validation: {
        requiredField: 'Feltet må fylles ut.',
        invalidPhone: 'Telefonnummeret er ikke gyldig.',
        invalidEmail: 'E-postadressen er ikke gyldig.',
        passwordsMismatch: 'Passord og bekreftelse må stemme overens.',
        passwordTooShort: 'Passordet er for kort.',
        usernameInvalid: 'Brukernavn kan ikke inneholde æ, ø eller å.',
        passwordDisallowedChars: 'Passord kan ikke inneholde æ, ø eller å.',
        lettersAndSpacesOnly: 'Bruk bare bokstaver og mellomrom.',
        usernameAllowedChars:
            "Kan bare inneholde bokstaver fra A til Z, tall og tegnene '. - _! # ^ ~",
        lengthBetween: 'Teksten må være mellom {{min}} og {{max}} tegn.',
        maxLength: 'Maksimalt {{max}} tegn.',
        orgSlugNoDoubleHyphen:
            'Bindestrek etterfulgt av bindestrek («--») er ikke tillatt.',
        orgSlugAllowedChars:
            'Kan kun inneholde små bokstaver, tall og bindestrek.',
        orgSlugStartEnd: 'Må starte og slutte med en bokstav eller et tall.',
    },
    home: {
        incomplete: {
            title: 'Uferdige videoer',
            deleted: 'Videoen er slettet',
            confirmDelete: 'Er du sikker på at du vil slette denne videoen?',
        },
        shortcuts: {
            newUser: 'Ny beboer',
            newCreator: 'Ny ansatt',
            newVideo: 'Lag ny video',
            uploadImages: 'Last opp bilder',
        },
    },
    nextOfKin: {
        title: 'Inviter pårørende',
        success: 'Pårørende ble opprettet',
        form: {
            firstName: 'Fornavn*',
            lastName: 'Etternavn*',
            phone: 'Telefonnummer',
            email: 'E-post*',
            relationLabel: 'Relasjon',
            selectRelation: 'Velg relasjon',
            relationFamily: 'Familie eller nær relasjon',
            relationGuardian: 'Ekstern person',
            isMainContactLabel: 'Hovedkontakt',
            isGuardianLabel: 'Verge',
            disableManagingRelativesLabel:
                'Deaktiver denne personens mulighet til å administrere pårørende',
            submit: 'Send invitasjon',
        },
        card: {
            deleteButton: 'Slett',
            deleteConfirm: 'Er du sikker på at du vil slette denne kontakten?',
            editButton: 'Rediger',
            editTitle: 'Rediger pårørende',
            editDescription: 'Oppdater kontaktinformasjonen til {{name}}.',
        },
        list: {
            title: 'Pårørende',
            empty: 'Ingen pårørende er lagt til ennå.',
        },
        actions: {
            new: 'Ny pårørende',
        },
        notifications: {
            deleted: 'Pårørende ble slettet.',
            updated: 'Pårørende ble oppdatert.',
            alreadyLinked: 'Denne pårørende er allerede koblet til beboeren.',
            emailBelongsToOtherRole:
                'Denne e-posten er allerede i bruk av en bruker som ikke er pårørende.',
        },
    },
    profile: {
        picture: {
            label: 'Profilbilde',
            change: 'Endre bilde',
            remove: 'Fjern bilde',
        },
        labels: {
            phone: 'Telefonnr',
            email: 'E-post',
            firstName: 'Fornavn*',
            lastName: 'Etternavn*',
            username: 'Brukernavn',
        },
        organization: {
            sectionTitle: 'Lisenser',
            usageSuffix: 'i bruk',
        },
        delete: {
            title: 'Slette konto?',
            description: 'Ved å slette kontoen mister du tilgang til Mundu',
            confirmLabel: "Skriv inn '{{value}}' for å slette",
            button: 'Slett konto',
        },
        language: 'Språk',
    },
    music: {
        validation: {
            playlistNameRequired: 'Listen må ha et navn.',
        },
    },
    session: {
        validation: {
            videoNameRequired: 'Navnet på videoen må fylles ut.',
        },
    },
    errors: {
        emailInUse: 'E-post er allerede i bruk.',
        phoneInUse: 'Telefonnummeret er allerede i bruk.',
        usernameInUse: 'Brukernavnet er allerede i bruk.',
        loginFailed: 'Kunne ikke logge inn. Prøv igjen.',
        accountNotActivated: 'Kontoen er ikke aktivert ennå.',
        missingAccessToken: 'Svar mangler tilgangstoken. Logg inn på nytt.',
        invalidCredentials: 'Feil brukernavn eller passord.',
        refreshFailed: 'Kunne ikke fornye innloggingen.',
        unknownRefresh: 'Ukjent feil ved fornying av token.',
        unknownLogin: 'Ukjent feil ved innlogging.',
        passwordChangeRequired:
            'Du må sette et nytt passord før du kan logge inn.',
    },
    roles: {
        admin: 'Admin',
        systemAdmin: 'Systemadministrator',
        organization: 'Superbruker',
        creator: 'Ansatt',
        nextOfKin: 'Pårørende',
        consumer: 'Beboer',
        unknown: 'Rolle',
    },
    messages: {
        unsavedChanges:
            'Obs! Du har ulagrede endringer. Er du sikker på at du vil forlate siden?',
    },
    modals: {
        confirmExitTitle: 'Ønsker du å avslutte?',
    },
    notifications: {
        authRequired: 'Du må være logget inn for å få tilgang til denne siden.',
        accessDenied: 'Du har ikke tilgang til denne siden.',
        profileUpdated: 'Profil oppdatert.',
    },
    webPushPermission: {
        title: 'Aktiver nettleservarsler',
        description:
            'Få påminnelser om hendelser og varsel når pårørende sender meldinger eller kommentarer.',
        blockedTitle: 'Varsler er blokkert',
        blockedDescription:
            'Aktiver varsler for denne siden i nettleserinnstillingene for å motta varsler om hendelser, meldinger og kommentarer.',
        enable: 'Aktiver varsler',
        enabling: 'Aktiverer...',
        notNow: 'Ikke nå',
    },
    nav: {
        home: 'Hjem',
    },
    modules: {
        moduleNavigation: {
            title: 'Moduler',
            notEnabled: 'Ikke aktivert',
            accessRequired: 'Ingen tilgang',
        },
        modulePages: {
            navigationLabel: 'Modulsider',
            main: 'Hovedside',
            settings: 'Innstillinger',
            settingsDescription:
                'Se tilganger og innstillinger for {{module}}-modulen.',
        },
        moduleEmployeeReadAccess: {
            title: 'Tilgang for ansatte',
            description: 'Velg om alle ansatte kan se {{module}}-modulen.',
            label: 'La alle ansatte se denne modulen',
            helper: 'Ansatte som ikke er medlemmer av modulen, får lesetilgang. Modulmedlemmer kan fortsatt administrere innholdet.',
            saving: 'Lagrer…',
            updated: 'Tilgangen for ansatte er oppdatert.',
        },
        moduleUnavailable: {
            notEnabledTitle: '{{module}} er ikke aktivert',
            notEnabledDescription:
                'Denne modulen er tilgjengelig, men er ikke aktivert for organisasjonen din.',
            notEnabledHelp:
                'Kontakt en organisasjonsadministrator eller Mundu hvis du ønsker å ta den i bruk.',
            accessRequiredTitle: 'Du trenger tilgang til {{module}}',
            accessRequiredDescription:
                'Modulen er aktivert, men kontoen din er ikke lagt til som medlem.',
            accessRequiredHelp:
                'Be en organisasjonsadministrator om å legge deg til i modulen.',
        },
        admin: {
            title: 'Admin',
            navOrganizations: 'Organisasjoner',
            newOrganization: 'Ny organisasjon',
            editOrganization: 'Rediger organisasjon',
            newAdmin: 'Ny administrator',
            organizationDetail: 'Organisasjon | {{name}}',
        },
        users: {
            headerNew: 'Ny beboer',
            navLabel: 'Beboere',
            passwordChangeRequired:
                'Du må velge et nytt passord før du kan fortsette.',
            newPasswordLabel: 'Nytt passord',
            newPasswordDescription:
                'Startpassordet virker bare én gang. Lag et nytt passord for å aktivere kontoen.',
            submitNewPassword: 'Lagre nytt passord',
            useDifferentAccount: 'Bruk en annen konto',
            navNew: 'Ny beboer',
            mainContacts: 'Hovedkontakter',
            empty: 'Ingen beboere ennå',
            mainContactFilters: {
                title: 'Beboere etter hovedkontaktenes innloggingsstatus',
                all: 'Alle',
                active: 'Aktive',
                invited: 'Invitert',
                empty: {
                    active: 'Ingen beboere med en aktiv hovedkontakt samsvarer med filtrene.',
                    invited:
                        'Ingen beboere med kun inviterte hovedkontakter samsvarer med filtrene.',
                },
                noMatches:
                    'Ingen beboere samsvarer med søket eller gruppefiltrene.',
            },
        },
        creators: {
            headerDefault: 'Ansatte',
            headerNew: 'Ny ansatt',
            headerProfile: 'Ansatte / profil',
            navLabel: 'Ansatte',
            navNew: 'Ny ansatt',
            empty: 'Ingen ansatte ennå',
        },
        myProfile: {
            title: 'Min profil',
        },
        organization: {
            navLabel: 'Organisasjon',
            settings: 'Innstillinger',
            documents: 'Dokumenter',
        },
        appContent: {
            navLabel: 'Dokumenter',
            documentsTitle: 'Dokumenter',
            documentCount_one: '{{count}} dokument',
            documentCount_other: '{{count}} dokumenter',
            noDocuments: 'Ingen dokumenter er delt ennå.',
            readOnlyLabel: 'Skrivebeskyttet',
            readOnlyNotice:
                'Du kan se disse dokumentene. Bare modulmedlemmer kan gjøre endringer.',
            members: {
                settingsDescription:
                    'Medlemmer kan administrere dokumentene beboere og pårørende ser i Mundu-appen.',
            },
        },
        calendar: {
            navLabel: 'Kalender',
            title: 'Kalender',
            newEvent: 'Ny hendelse',
            notEnabled:
                'Kalendermodulen er ikke aktivert for denne organisasjonen.',
            responseStatus: {
                tabLabel: 'Svar',
                replyProgress: '{{replied}} / {{total}} har svart',
                noInvitees: 'Ingen inviterte',
                title: 'Svarstatus',
                reminder: {
                    sendWithCount: 'Send svarpåminnelse til {{count}} personer',
                    send: 'Send svarpåminnelse',
                    retry: 'Prøv mislykkede på nytt · {{count}}',
                    confirm:
                        'Sende svarpåminnelse til {{count}} som venter på å svare?',
                    result: 'Sendt: {{sent}}. Mislyktes: {{failed}}.',
                    history:
                        'Siste påminnelser: {{sent}} sendt, {{failed}} mislyktes.',
                    sent: 'Påminnelse sendt',
                    failed: 'Påminnelse mislyktes',
                    error: 'Kunne ikke sende svarpåminnelser. Prøv igjen.',
                },
                totalInvited: 'Invitert totalt',
                going: 'Kommer',
                notGoing: 'Kommer ikke',
                waitingForReply: 'Venter på svar',
                noResponse: 'Ingen svar',
                relativeOf: 'Pårørende til',
                all: 'Alle',
                responseColumn: 'Svar',
                respondedAt: 'Svarte',
                closedNotice:
                    'Svarfristen gikk ut {{date}}. Denne listen er endelig.',
                unnamed: 'Navn mangler',
                empty: 'Ingen her ennå.',
                loadError: 'Kunne ikke laste svarstatus. Prøv igjen.',
            },
            form: {
                createTitle: 'Ny hendelse',
                editTitle: 'Rediger hendelse',
                detailsTab: 'Detaljer',
                viewTitle: 'Hendelsesdetaljer',
                readOnlyLabel: 'Skrivebeskyttet hendelse',
                cancelledLabel: 'Avlyst',
                cancelledNotice: 'Denne hendelsen er avlyst.',
                cancelledManageNotice:
                    'Denne hendelsen er avlyst. Gjenopprett den for å redigere den igjen.',
                readOnlyNotice:
                    'Bare den ansatte som opprettet hendelsen, eller en organisasjonsadministrator, kan redigere eller slette den.',
                moduleMembershipReadOnlyNotice:
                    'Du kan se kalenderhendelser, men bare medlemmer av kalendermodulen kan opprette hendelser og administrere hendelser de selv har opprettet.',
                detailsSectionTitle: 'Hendelsesdetaljer',
                organizerLabel: 'Arrangør',
                organizerUnknown: 'Ukjent arrangør',
                scheduleSectionTitle: 'Dato og tid',
                titleLabel: 'Tittel',
                descriptionLabel: 'Beskrivelse',
                locationLabel: 'Sted',
                typeLabel: 'Hendelsestype',
                removeRoomsToUseOpen:
                    'Fjern valg av enkeltrom for å bruke Fellesaktivitet.',
                groupAudienceHint:
                    'Gruppeaktiviteter krever at du velger avdelinger, grupper eller rom.',
                types: {
                    residents: {
                        label: 'Fellesaktivitet',
                        description:
                            'For alle i valgte avdelinger eller grupper, eller hele organisasjonen. Pårørende kan se hendelsen, men mottar ikke varsler.',
                    },
                    internal: {
                        label: 'Intern',
                        description: 'Kun synlig for ansatte.',
                    },
                    group: {
                        label: 'Gruppeaktivitet',
                        description:
                            'For valgte avdelinger, grupper og enkeltrom. Deres pårørende kan se hendelsen, men mottar ikke varsler.',
                    },
                    relatives: {
                        label: 'Pårørende',
                        description:
                            'Synlig for inviterte beboere, pårørende og ansatte. Inviterte pårørende mottar varsler.',
                    },
                },
                requestReplyTitle: 'Be om svar',
                requireResponse: 'Krev svar (kun hovedkontakter)',
                requireResponseSeriesOnly:
                    'Rediger hele serien for å endre denne innstillingen.',
                requireResponseFutureStart:
                    'Flytt starttidspunktet for hendelsen frem i tid for å be om svar.',
                disableResponseConfirm:
                    'Slutte å be om svar for kommende hendelser? Eksisterende svar og tidligere svarstatus blir bevart.',
                rsvpScheduleChangeConfirm:
                    'Tidligere svar og hendelser som blir værende, bevares. Svar for kommende hendelser som fjernes, slettes.',
                rsvpScheduleChangeTitle: 'Endre hendelsesplan?',
                rsvpScheduleChangeProceed: 'Endre plan',
                residentAudienceCount: '{{value}} beboere',
                residentAudienceCount_one: '{{count}} beboer',
                residentAudienceCount_other: '{{count}} beboere',
                relativeAudienceCount: '{{value}} pårørende',
                relativeAudienceCount_one: '{{count}} pårørende',
                relativeAudienceCount_other: '{{count}} pårørende',
                mainContactAudienceCount: '{{value}} hovedkontakter',
                mainContactAudienceCount_one: '{{count}} hovedkontakt',
                mainContactAudienceCount_other: '{{count}} hovedkontakter',
                mainContactInvitationCount:
                    '{{value}} hovedkontakter vil motta invitasjonen',
                mainContactInvitationCount_one:
                    '{{count}} hovedkontakt vil motta invitasjonen',
                mainContactInvitationCount_other:
                    '{{count}} hovedkontakter vil motta invitasjonen',
                audienceCountUnavailable: 'Utilgjengelig',
                audiencePreviewError:
                    'Kunne ikke laste antall beboere og pårørende.',
                colorLabel: 'Hendelsesfarge',
                internalColor: 'Intern hendelse',
                iconLabel: 'Hendelsesikon',
                noIcon: 'Ingen ikon',
                icons: {
                    calendar: 'Generell hendelse',
                    singing: 'Sang',
                    music: 'Musikk',
                    dancing: 'Dans',
                    hiking: 'Fottur',
                    outdoors: 'Utendørs',
                    park: 'Park',
                    gardening: 'Hagearbeid',
                    dinner: 'Middag',
                    coffee: 'Kaffe',
                    drinks: 'Bar og drikke',
                    baking: 'Baking',
                    games: 'Spill',
                    reading: 'Lesing',
                    film: 'Film',
                    arts: 'Kunst',
                    crafts: 'Håndarbeid',
                    exercise: 'Trening',
                    sports: 'Sport',
                    swimming: 'Svømming',
                    trip: 'Utflukt',
                    celebration: 'Feiring',
                    social: 'Sosialt',
                    wellbeing: 'Velvære',
                    animals: 'Dyr',
                },
                colors: {
                    plum: 'Plomme',
                    terracotta: 'Terrakotta',
                    coral: 'Korall',
                    rose: 'Rosa',
                    violet: 'Fiolett',
                    blue: 'Blå',
                    teal: 'Blågrønn',
                    green: 'Grønn',
                    olive: 'Oliven',
                    gold: 'Gull',
                },
                startLabel: 'Starter',
                endLabel: 'Slutter',
                allDayLabel: 'Heldagshendelse',
                recurrenceLabel: 'Gjentas',
                doesNotRepeat: 'Gjentas ikke',
                recurrenceDaily: 'Daglig',
                recurrenceWeekly: 'Ukentlig',
                recurrenceWeeklyOn: 'Ukentlig på {{weekday}}',
                recurrenceMonthly: 'Månedlig',
                recurrenceMonthlyOnDay: 'Månedlig på dag {{day}}',
                recurrenceUntilLabel: 'Gjentas til',
                recurrenceUntilRequired:
                    'Velg når hendelsesserien skal avsluttes.',
                recurrenceUntilBeforeStart:
                    'Hendelsesserien kan ikke slutte før den starter.',
                seriesEditNotice:
                    'Endringer gjelder den gjentakende serien. Eksisterende endringer i enkelthendelser beholdes.',
                occurrenceEditNotice:
                    'Innstillinger for gjentakelse, hendelsestype og deltakere forblir de samme for serien.',
                seriesExceptionResetNotice:
                    'Hvis du endrer starten eller gjentakelsesmønsteret for serien, fjernes endringer som er gjort i enkelthendelser.',
                editRecurringTitle: 'Rediger gjentakende hendelse',
                editRecurringPrompt: 'Hvilke hendelser vil du endre?',
                thisEvent: 'Denne hendelsen',
                allEvents: 'Alle hendelser',
                attendeesLabel: 'Deltakere',
                attendeeCount: '{{count}} personer',
                internalLabel: 'Intern hendelse – kun synlig for ansatte',
                sendToAllLabel: 'Alle i organisasjonen',
                sendToAllLabelWithOrg: 'Alle hos {{organizationName}}',
                targetsRequired: 'Velg minst én gruppe eller alle.',
                endBeforeStart: 'Hendelsen kan ikke slutte før den starter.',
                submit: 'Opprett hendelse',
                update: 'Lagre endringer',
                discardConfirmTitle: 'Forkaste endringene?',
                discardConfirm:
                    'Du har ulagrede endringer. Hvis du går ut nå, går endringene tapt.',
                keepEditing: 'Fortsett å redigere',
                discardChanges: 'Forkast endringene',
                delete: 'Slett hendelse',
                cancelEvent: 'Avlys hendelse',
                keepEvent: 'Behold hendelsen',
                deleteSeries: 'Slett serie',
                deleteThisEvent: 'Slett denne hendelsen',
                deleteAllEvents: 'Slett alle hendelser',
                deleteConfirmTitle: 'Slette hendelsen?',
                deleteConfirm:
                    'Vil du slette "{{title}}" permanent? Den vil ikke lenger være synlig for noen.',
                deleteInternalConfirm:
                    'Er du sikker på at du vil slette den interne hendelsen "{{title}}"?',
                deleteSeriesConfirmTitle: 'Slette gjentakende hendelse?',
                deleteSeriesConfirm:
                    'Vil du slette hele serien "{{title}}" permanent? Den vil ikke lenger være synlig for noen.',
                deleteInternalSeriesConfirm:
                    'Er du sikker på at du vil slette hele serien med interne hendelser "{{title}}"? Alle hendelsene i serien fjernes.',
                deleteRecurringPrompt:
                    'Vil du slette bare denne hendelsen eller alle hendelsene i serien?',
                cancelConfirmTitle: 'Avlyse hendelsen?',
                cancelSeriesConfirmTitle: 'Avlyse gjentakende hendelse?',
                cancelConfirm:
                    'Vil du avlyse "{{title}}"? Den forblir synlig som avlyst, og deltakerne blir varslet.',
                cancelRecurringPrompt:
                    'Vil du avlyse bare denne hendelsen eller alle hendelsene i serien?',
                cancelThisEvent: 'Avlys denne hendelsen',
                cancelAllEvents: 'Avlys alle hendelser',
                restoreEvent: 'Gjenopprett hendelse',
            },
            notifications: {
                created: 'Hendelse opprettet.',
                updated: 'Hendelse oppdatert.',
                deleted: 'Hendelse slettet.',
                cancelled: 'Hendelse avlyst.',
                restored: 'Hendelse gjenopprettet.',
            },
            tabs: {
                ariaLabel: 'Kalenderseksjoner',
                calendar: 'Kalender',
                myEvents: 'Mine hendelser',
                readView: 'Utskriftsvisning',
            },
            readView: {
                printOrSave: 'Skriv ut eller lagre',
            },
            myEvents: {
                filterAriaLabel: 'Filtrer mine hendelser',
                allInDepartment: 'Alle i min avdeling',
                createdByMe: 'Opprettet av meg',
                departmentShort: 'Min avdeling',
                createdByMeShort: 'Opprettet av meg',
            },
            members: {
                manage: 'Administrer medlemmer',
                title: 'Kalendermodul-medlemmer',
                helper: 'Medlemmer kan se og administrere kalenderen. Legg til ansatte fra listen nedenfor.',
                settingsDescription:
                    'Medlemmer kan opprette og redigere hendelser. Alle i organisasjonen kan fortsatt se kalenderen.',
                count: '{{count}} medlemmer',
                countWithLimit: '{{count}} av {{limit}} medlemmer',
                limitReached:
                    'Medlemsgrensen ({{limit}}) er nådd. Fjern et medlem for å legge til noen andre.',
                updated: 'Medlemmer oppdatert.',
            },
            views: {
                allDay: 'Hele dagen',
                viewPickerAriaLabel: 'Velg kalendervisning',
                previous: 'Tilbake',
                next: 'Neste',
                today: 'I dag',
                month: 'Måned',
                week: 'Uke',
                weekNumber: 'Uke {{week}}',
                day: 'Dag',
                agenda: 'Liste',
                date: 'Dato',
                time: 'Tid',
                event: 'Hendelse',
                now: 'Nå {{time}}',
                recurringEvent: 'Gjentakende hendelse',
                noEventsInRange: 'Ingen hendelser i denne perioden.',
                showMore: '+{{total}} til',
            },
        },
        messages: {
            navLabel: 'Meldinger',
            listTitle: 'Siste meldinger',
            createTitle: 'Send en ny melding',
            actions: 'Meldingshandlinger',
            edit: 'Rediger melding',
            editTitle: 'Rediger melding',
            editSave: 'Lagre endringer',
            editSuccess: 'Melding oppdatert.',
            deleteConfirmTitle: 'Slette melding?',
            deleteConfirmMessage: 'Er du sikker på at du vil slette meldingen?',
            backToList: 'Tilbake til meldinger',
            listEmpty: 'Ingen meldinger er sendt ennå.',
            listRefreshing: 'Oppdaterer meldinger…',
            deleteSuccess: 'Melding slettet.',
            targetAll: 'Sendt til alle',
            target: 'Sendt til {{value}}',
            targetRelatives: 'Sendt til pårørende til {{value}}',
            sentBy: 'av {{value}}',
            sentByUnknown: 'av ukjent bruker',
            commentsOpen: 'Åpne kommentarer',
            commentsClose: 'Lukk kommentarer',
            commentsOpened: 'Kommentarer åpnet.',
            commentsClosedNotice: 'Kommentarer lukket.',
            commentsTitle: 'Kommentarer',
            commentsEmpty: 'Ingen kommentarer ennå.',
            commentsClosed: 'Kommentarer er lukket.',
            commentsShowOlder: 'Vis eldre kommentarer ({{count}})',
            commentsShowLatest: 'Vis de siste {{count}} kommentarene',
            commentsEdit: 'Rediger',
            commentsEditSave: 'Lagre',
            commentsEditSuccess: 'Kommentar oppdatert.',
            commentsDeleteSuccess: 'Kommentar slettet.',
            commentsDeleteConfirmTitle: 'Slette kommentar?',
            commentsDeleteConfirmMessage:
                'Er du sikker på at du vil slette kommentaren?',
            commentsLabel: 'Skriv kommentar:',
            commentsSubmit: 'Send kommentar',
            commentsViewsButtonLabel:
                'Vis hvem som åpnet meldingen etter denne kommentaren',
            commentsNoViews: 'Ingen ennå.',
            viewsViewedBy: 'Sett av',
            viewsUnknownViewer: 'Ukjent bruker',
            viewsAriaLabel: 'Visninger: {{count}}',
            filters: {
                title: 'Filtre',
                all: 'Alle',
                personal: 'Personlig',
                sentToAll: 'Sendt til alle',
                sentByMe: 'Sendt av meg',
                openDialogues: 'Åpne dialoger',
                unread: 'Ulest',
                departments: 'Avdelinger',
                departmentsPlaceholder: 'Velg avdelinger',
                residentGroups: 'Beboergrupper',
                residentGroupsPlaceholder: 'Velg beboergrupper',
                levelPlaceholder: 'Velg {{levelName}}',
                noStaffReply: 'Uten svar fra ansatt',
                noStaffReplyCount: '{{count}} samtaler',
                noStaffReplyCount_one: '{{count}} samtale',
                period: 'Meldingsperiode',
                allTime: 'Hele perioden',
                selectedMonth: 'Måned',
                month: 'Måned',
                analyticsHint: 'Samsvarer med analyseoversikten',
                fromAnalytics: 'Fra analyse',
                clearAnalytics: 'Fjern filtrene fra analysen',
            },
            form: {
                noOrganization:
                    'Du må tilhøre en organisasjon for å se meldinger.',
                noPermission:
                    'Du har ikke tillatelse til å sende meldinger i denne organisasjonen.',
                subjectLabel: 'Emne*',
                bodyLabel: 'Melding',
                recipientsLabel: 'Mottakere*',
                recipientsTitle: 'Mottakere',
                recipientsPlaceholder: 'Velg pårørende',
                recipientsEmpty: 'Ingen pårørende tilgjengelig.',
                recipientsRequired: 'Velg minst én pårørende.',
                recipientsAllRelatives: 'Alle pårørende',
                recipientsBadgeMainContact: 'Hovedkontakt',
                recipientsBadgeMainContactShort: 'H',
                recipientsBadgeGuardian: 'Verge',
                recipientsBadgeGuardianShort: 'V',
                attachmentsLabel: 'Vedlegg (PDF, bilder, video)',
                unsupportedAttachmentType:
                    'Kun JPEG-, PNG-, WebP-, HEIC-, PDF- eller videofiler er tillatt.',
                attachmentConversionFailed:
                    'Dette HEIC-bildet kunne ikke konverteres. Eksporter det som JPEG og legg det ved på nytt.',
                sendToAllLabel: 'Send til alle',
                sendToAllLabelWithOrg: 'Send til alle hos {{organizationName}}',
                sendToMainContactsLabel: 'Send kun til hovedkontakter',
                commentsEnabledLabel: 'Åpne for kommentarer',
                emptyGroupsWarning:
                    'Disse gruppene har ingen beboere tilknyttet: {{groups}}',
                emptyGroupsCta: 'Legg til beboere',
                emptyGroupsCtaNonOrg: 'Kontakt {{name}} ({{email}})',
                noNextOfKinWarning:
                    'Det er {{count}} beboere uten registrerte pårørende.',
                noNextOfKinCta: 'Legg til pårørende under fanen Beboere',
                targetsRequired:
                    'Velg minst én mottaker før du sender meldingen.',
                submit: 'Send melding',
            },
            notifications: {
                created: 'Melding sendt.',
            },
            attachmentsHeading: 'Vedlegg',
            attachmentsPreviousImage: 'Forrige bilde',
            attachmentsNextImage: 'Neste bilde',
            attachmentsSaveImage: 'Lagre bilde',
            attachmentsImageSaved: 'Bildet er lagret.',
            attachmentsImageSaveError: 'Bildet kunne ikke lagres.',
        },
        analytics: {
            navLabel: 'Analyse',
            members: {
                settingsDescription:
                    'Medlemmer kan se analysen for denne organisasjonen. Administratorer har alltid tilgang.',
            },
        },
        infoScreen: {
            navLabel: 'Infoskjerm',
            header: 'Infoskjerm',
            members: {
                manage: 'Administrer medlemmer',
                title: 'Medlemmer av infoskjermmodulen',
                helper: 'Medlemmer kan se og administrere infoskjermen. Legg til ansatte fra listen nedenfor.',
                settingsDescription:
                    'Medlemmer kan administrere innholdet på infoskjermen og TV-oppsettet.',
                updated: 'Medlemmer oppdatert.',
            },
            loading: 'Laster infoskjerm…',
            readOnlyNotice:
                'Du kan se denne modulen. Bare modulmedlemmer og organisasjonsadministratorer kan gjøre endringer.',
            readOnlySlidesShown: 'Aktive bilder som vises på TV-en: {{count}}',
            slidesTitle: 'Bilder',
            slidesShown: '{{active}} av {{total}} bilder vises på TV-en',
            saveChanges: 'Lagre endringer',
            saving: 'Lagrer…',
            saved: 'Infoskjermen er lagret.',
            unsavedChanges: 'Du har ulagrede endringer',
            secondsPerSlide: 'Sekunder per bilde',
            addSlide: 'Legg til bilde',
            uploading: 'Laster opp…',
            reorderHint:
                'Dra bildene, eller bruk ‹ ›-knappene på det valgte bildet, for å endre rekkefølgen de vises i.',
            slideCounter: 'Bilde {{current}} av {{total}}',
            moveEarlier: 'Flytt frem',
            moveLater: 'Flytt bak',
            prevSlide: 'Forrige bilde',
            nextSlide: 'Neste bilde',
            hiddenBadge: 'Skjult',
            shownOnTv: 'Vises på TV-en',
            hiddenFromTv: 'Skjult fra TV-en',
            deleteSlide: 'Slett',
            deleteConfirmTitle: 'Slette bildet?',
            deleteConfirmMessage:
                '«{{name}}» fjernes fra infoskjermen når du lagrer.',
            imageHint:
                'Alle bildestørrelser fungerer; liggende bilder ser som regel best ut på TV.',
            fitLabel: 'Bildevisning',
            fitCover: 'Fyll',
            fitContain: 'Tilpass',
            uploadImage: 'Last opp bilder',
            uploadHint: 'Dra og slipp bilder her, eller bla gjennom filer.',
            dropToAdd: 'Slipp bildene for å legge dem til',
            onlyImages: 'Kun bildefiler kan legges til.',
            uploadFailed: 'Kunne ikke legge til det valgte bildet.',
            maxSlides: 'Maks {{max}} bilder er tillatt.',
            previewTitle: 'Forhåndsvisning',
            previewEmpty: 'Ingen bilder vises på TV-en ennå',
            tvLinkTitle: 'TV-lenke',
            tvLinkDescription:
                'Alle TV-er som åpner denne lenken, viser bildene dine.',
            copyLink: 'Kopier lenke',
            linkCopied: 'TV-lenken er kopiert.',
            regenerate: 'Lag ny lenke',
            regenerateConfirmTitle: 'Lage en ny TV-lenke?',
            regenerateConfirmMessage:
                'Den gamle lenken slutter å virke med en gang, og alle TV-er må settes opp på nytt med den nye lenken.',
            linkRegenerated: 'Ny TV-lenke er laget.',
            setupTitle: 'Slik setter du opp TV-en',
            setupStep1: 'Åpne nettleseren på TV-en eller infoskjermen.',
            setupStep2: 'Skriv inn TV-lenken som vises over.',
            setupStep3: 'Sett nettleseren til å åpne denne siden ved oppstart.',
            setupStep4: 'Bytt til fullskjermmodus før du forlater TV-en.',
            publicNotFound: 'Fant ikke infoskjermen',
            publicLoading: 'Laster…',
            publicNoSlides: 'Ingen aktive bilder',
        },
        moduleMembers: {
            title: 'Medlemmer',
            count: '{{count}} medlemmer',
            countWithLimit: '{{count}} av {{limit}} medlemmer',
            edit: 'Rediger medlemmer',
            addTitle: 'Legg til medlemmer',
            add: 'Legg til',
            remove: 'Fjern',
            searchLabel: 'Søk etter ansatte',
            searchPlaceholder:
                'Søk etter konto med navn, e-post eller telefonnummer',
            empty: 'Ingen medlemmer er lagt til ennå. Legg til minst ett medlem for å gi redigeringstilgang til denne modulen.',
            noAvailable: 'Ingen tilgjengelige kontoer samsvarer med søket.',
            adminOnly:
                'Bare organisasjonsadministratorer kan endre modulmedlemmer.',
            saving: 'Lagrer…',
            updated: 'Modulmedlemmene er oppdatert.',
            noEditingAccess:
                'Kontoen din har for øyeblikket ikke redigeringstilgang.',
            addSelfDescription:
                'Legg til deg selv som modulmedlem for å opprette og redigere innhold.',
            addSelfLimitReached:
                'Medlemsgrensen må økes, eller et annet medlem må fjernes, før du kan legge til deg selv.',
            addSelf: 'Legg til meg',
            addedSelf: 'Kontoen din har nå redigeringstilgang.',
            limitReached:
                'Medlemsgrensen ({{limit}}) er nådd. Fjern et medlem for å legge til noen andre.',
            formerEmployee: 'Tidligere ansatt',
            formerEmployeeDescriptionShort:
                'Denne ansatte er ikke lenger tilgjengelig ({{id}}).',
            formerEmployeeDescription:
                'Dette lagrede medlemmet finnes ikke lenger ({{id}}). Fjern personen og lagre endringene.',
        },
    },
    admin: {
        analytics: {
            departmentScope:
                'Viser beboerne i avdelingen, deres pårørende, og ansatte og meldinger som hører til avdelingen.',
            fullTimeScope:
                'Innlogging og aktivitet teller kun heltidsansatte. Totalen inkluderer deltidsansatte.',
            employeeTypeBreakdown:
                '{{fullTime}} heltid · {{partTime}} kun deltid',
            fullTimeEmployees: 'Heltidsansatte',
            allDepartments: 'Alle avdelinger',
            departments: 'Avdelinger',
            department: 'Avdeling',
            coverageView: 'Diagramvisning',
            coverageCurrent: 'Nå',
            coverageMonthly: 'Månedlig',
            employeeCoverageTitle: 'Aktivitet blant heltidsansatte',
            employeeCoverageScope:
                'Nåværende heltidsansatte, med registrert aktivitet de siste 30 dagene.',
            employeeHistoryScope:
                'Lagret månedlig aktivitetsstatus for ansatte som nå er heltidsansatte i dette utvalget.',
            employeeChartSummary:
                '{{active}}/{{total}} ansatte aktive de siste 30 dagene · {{percent}}%.',
            employeeCoverageNote:
                'Aktiv: har brukt Mundu de siste 30 dagene. Inaktiv: har logget inn før, men ikke de siste 30 dagene. Invitert: har aldri logget inn. Hver ansatt telles én gang.',
            employeeHistoryNote:
                'Status ved slutten av hver måned, for dagens heltidsansatte. En måned uten søyle har ingen data.',
            coverageHistoryTitle:
                'Månedlig oversikt over beboere etter hovedkontaktaktivitet',
            coverageHistoryScope:
                'Antall beboere fordelt etter hovedkontaktstatus, basert på siste lagrede øyeblikksbilde hver måned.',
            coverageHistoryError:
                'Kunne ikke laste månedlig dekning. Prøv å oppdatere.',
            coverageHistoryEmpty:
                'Ingen komplette øyeblikksbilder ennå. Månedlig historikk starter når øyeblikksbilder og aktivitetssporing er tilgjengelige.',
            coverageHistoryUnavailable: 'Ingen komplett registrering',
            snapshotTaken: 'Registrert {{date}}',
            coverageHistorySnapshot: 'Registreringsdato',
            coverageHistoryPartialLabel: 'Delvis',
            coverageHistoryPartial:
                '* Inneværende måned, mindre enn 30 dager med aktivitetssporing eller en tidligere siste registrering. Manglende måneder har ingen søyle.',
            coverageHistoryNote:
                'Beboernes hovedkontaktstatus ved slutten av hver måned. Tidligere måneder endres ikke. En måned uten søyle har ingen data.',
            mainContactCoverageTitle: 'Beboere etter hovedkontaktaktivitet',
            mainContactChartSummary:
                '{{active}}/{{total}} beboere har en aktiv hovedkontakt · {{percent}}%.',
            mainContactChart_active: 'Aktiv',
            mainContactChart_neverLoggedIn: 'Invitert',
            mainContactChart_previouslyLoggedIn: 'Inaktiv',
            mainContactChart_noLinkedContact: 'Ingen hovedkontakt',
            mainContactCoverageScope:
                'Dagens beboere med registrert aktivitet fra hovedkontakter de siste 30 dagene.',
            withActiveMainContact: 'Med en aktiv hovedkontakt',
            withoutActiveMainContact: 'Uten en aktiv hovedkontakt',
            mainContact_noLinkedContact: 'Ingen hovedkontakt tilknyttet',
            mainContact_neverLoggedIn:
                'Hovedkontakter invitert, ingen har logget inn ennå',
            mainContact_previouslyLoggedIn: 'Tidligere innlogget, ingen aktive',
            mainContactCoverageNote:
                'Hver beboer telles én gang, etter den mest aktive hovedkontakten. Aktiv: har brukt Mundu de siste 30 dagene. Inaktiv: har logget inn før, men ikke nylig. Invitert: ingen hovedkontakt har logget inn ennå.',
            timeFreedTitle: 'Frigjort tid',
            timeFreedScope:
                'Anslag for alle opprinnelige meldinger fra organisasjoner og pårørende i valgt periode.',
            defaultAssumption: 'Standardanslag · {{minutes}} min per melding',
            customAssumption: 'Ditt anslag · {{minutes}} min per melding',
            editAssumption: 'Endre minutter spart per melding',
            minutesPerMessage: 'Minutter spart per opprinnelig melding',
            applyAssumption: 'Bruk',
            cancelAssumption: 'Avbryt',
            resetAssumption: 'Bruk standardanslaget på 10 minutter',
            timeFreedCalculation:
                'Et anslag: opprinnelige meldinger × minutter spart per melding. Endre minuttene med blyanten.',
            organizationsAndStaff: 'Organisasjoner og ansatte',
            organizationsAndStaff_organization: 'Avdelinger og ansatte',
            residentsAndRelatives: 'Beboere og pårørende',
            relativeRoles: 'Pårørenderoller',
            active_employees: 'Aktive heltidsansatte',
            active_mainContacts: 'Aktive hovedkontakter',
            exportCsv: 'Eksporter CSV',
            activeUsers: 'Observerte aktive brukere',
            activeWindow:
                'Siste 1, 7 og 30 dager. Uavhengig av valgt aktivitetsmåned.',
            active_employees_day: 'Aktive de siste 24 timene',
            active_employees_week: 'Aktive de siste 7 dagene',
            active_employees_month: 'Aktive de siste 30 dagene',
            active_mainContacts_day: 'Aktive de siste 24 timene',
            active_mainContacts_week: 'Aktive de siste 7 dagene',
            active_mainContacts_month: 'Aktive de siste 30 dagene',
            activeCoverage: 'Dekning med aktive hovedkontakter',
            activeCoverageNote:
                'Dagens beboere med hovedkontakter som har brukt Mundu de siste 30 dagene.',
            coveredResidents: 'Beboere med en aktiv hovedkontakt',
            coveredCount: '{{count}} av {{total}} beboere',
            activeMainContactLinks: '{{label}} aktive hovedkontakter',
            activeMainContactLinks_one: '{{label}} aktiv hovedkontakt',
            trackingSince: 'Aktivitetssporingen startet {{date}}.',
            activityAppNote:
                'Aktivitet på mobil telles fra nyeste versjon av appen, så de som fortsatt bruker en eldre versjon telles ikke ennå.',
            trackingNotStarted: 'Ingen registrert aktivitet ennå.',
            infoFor: 'Informasjon om {{title}}',
            trackedActivityTitle: 'Brukeraktivitet og dekning',
            chooseDrilldownOrganization: 'Velg en organisasjon',
            openNoStaffReplyInSupport:
                'Åpne organisasjonen i skrivebeskyttet støttemodus med filteret Uten svar fra ansatt valgt.',
            viewNoStaffReply: 'Vis samtaler uten svar fra ansatt',
            openWithoutRelativesInSupport:
                'Åpne organisasjonen i skrivebeskyttet støttemodus med beboere uten tilknyttede pårørende uthevet.',
            viewResidentsWithoutRelatives:
                'Vis beboere uten tilknyttede pårørende',
            openInvitedInSupport:
                'Åpne organisasjonen i skrivebeskyttet støttemodus med filteret Invitert valgt.',
            viewNeverLoggedInEmployees: 'Vis inviterte ansatte',
            viewNeverLoggedInMainContacts:
                'Vis beboere der alle hovedkontakter er invitert',
            activity: 'Aktivitet',
            period: 'Aktivitetsperiode',
            allTime: 'Hele perioden',
            currentMonth: 'Inneværende måned',
            activityAsOf: 'Oppdatert {{date}}.',
            previousPeriod:
                'Viser forrige periode til de forespurte tallene er tilgjengelige.',
            monthlyScope:
                'Gjelder all aktivitet nedenfor. Måneder følger norsk tid, og slettede oppføringer er utelatt.',
            comments: 'Kommentarer',
            allDirections: 'Fra alle avsendere i valgt periode.',

            howCounted: 'Slik telles dette',
            selectedMonth: 'Valgt måned',
            timeFreedShort: 'Antar 10 min spart per melding',
            selectChartMonth:
                'Velg {{month}} · {{count}} opprinnelige meldinger',
            trendTitle: 'Meldinger per måned',
            trendShort: 'Kommentarer telles separat.',
            audienceTitle: 'Mottakergrupper',
            audienceNote: 'Hvem opprinnelige meldinger ble sendt til.',
            responseShort: 'Startet i valgt periode. Svarstatus per i dag.',
            calendarShort: 'Opprettet eller besvart i valgt periode.',

            estimatedTimeFreed: 'Estimert frigjort tid',
            timeFreedAssumption:
                'Forutsetter 10 minutter spart per opprinnelige melding fra organisasjonen eller pårørende som erstatter en telefon. Svar og antall mottakere er utelatt. Dette er et estimat, ikke målt tidsbesparelse.',
            title: 'Statistikk',
            refresh: 'Oppdater',
            homeType: 'Boligtype',
            allHomes: 'Alle boligtyper',
            organizations: 'Organisasjoner',
            allOrganizations: 'Alle organisasjoner',
            reportingMonth: 'Rapporteringsmåned',
            scopeNote:
                'Filtrene gjelder hele siden. Velg ingen organisasjoner for å ta med alle boliger av valgt type.',
            scopeNote_organization:
                'Tallene gjelder kun denne organisasjonen. Avdelingsfilteret gjelder hele siden.',
            people: 'Organisasjoner og personer',
            residents: 'Beboere',
            relatives: 'Pårørende',
            employees: 'Ansatte',
            mainContacts: 'Hovedkontakter',
            guardians: 'Verger',
            guardianNote:
                'Pårørende merket som verge i profilen. Telles separat fra hovedkontakter.',
            residentsWithMainContactCount:
                '{{count}} av {{total}} beboere har minst én hovedkontakt.',
            relativeTypeBreakdown:
                '{{mainContacts}} hovedkontakter · {{others}} andre pårørende',
            mainContactsPerResident:
                '{{value}} hovedkontakter per beboer i snitt.',
            mainContactsScope:
                'Innlogging og aktivitet for pårørende teller kun hovedkontakter. Totalen inkluderer alle pårørende.',
            perResident: '{{value}} per beboer',
            activationDetail:
                '{{activated}} har logget inn · {{never}} har aldri logget inn · {{unknown}} ukjent',
            residentConnections: 'Pårørende per beboer',
            linkedRelatives: '{{label}} tilknyttede pårørende',
            coverageNote:
                'Hvor mange pårørende som er knyttet til hver beboer.',
            permissions: 'Roller og tilganger',
            organizationAdmins: 'Organisasjonsadministratorer',
            employeeManagers: 'Ansatte som kan legge til/redigere ansatte',
            broadcasters: 'Ansatte som kan sende til alle',
            familyRelatives: 'Pårørende med familierolle',
            externalRelatives: 'Pårørende med ekstern rolle',
            permissionsNote: 'En person kan ha flere roller.',
            messages: 'Meldinger',
            direction: 'Meldingsretning',
            direction_all: 'Alle',
            direction_organization: 'Fra organisasjonen',
            direction_relative: 'Fra pårørende',
            originalMessages: 'Opprinnelige meldinger',
            messagesPerResident: '{{value}} per nåværende beboer',
            organizationReplies: 'Fra organisasjonen',
            relativeReplies: 'Fra pårørende',
            recordedReads: 'Registrerte mottakervisninger',
            trendDescription:
                'Opprinnelige meldinger per måned de siste 12 månedene til og med inneværende måned',
            trendNote:
                'Meldinger som starter en samtale. Kommentarer telles for seg.',
            audienceAll: 'Alle mottakere',
            audienceGroup: 'Gruppemottakere',
            audienceIndividual: 'Enkeltmottakere',
            readNote:
                'Teller hver kombinasjon av opprinnelig melding og mottaker én gang, for meldinger opprettet i valgt periode, slik det er registrert nå. Én person som ser fem meldinger, teller fem ganger. Gjentatte visninger av samme melding teller én gang. Visning i meldingslisten på mobil kan registreres. Dette bekrefter ikke at meldingen er lest nøye eller at et varsel er levert. Slettede meldinger og kommentarer er ikke inkludert.',
            relativeConversations: 'Samtaler startet av pårørende',
            answered: 'Besvart av ansatt',
            unanswered: 'Uten svar fra ansatt',
            medianResponse: 'Median svartid',
            hours: '{{value}} t',
            replied24h: 'Besvart innen 24 timer',
            replied48h: 'Besvart innen 48 timer',
            replied72h: 'Besvart innen 72 timer',
            eligibleThreads: 'Basert på {{count}} besvarte samtaler',
            conversationShare: '{{count}}/{{total}} samtaler',
            responseNote:
                'Samtaler pårørende startet i valgt periode. Et svar er den første kommentaren fra en ansatt. Timer regnes med netter og helger. Andelene for 24, 48 og 72 timer teller bare samtaler som er minst så gamle.',
            calendar: 'Kalender',
            eventsCreated: 'Kalenderoppføringer opprettet',
            rsvpResponses: 'RSVP-svar',
            eventType_residents: 'Åpent for alle',
            eventType_internal: 'Internt',
            eventType_group: 'Gruppe',
            eventType_relatives: 'Pårørende',
            calendarNote:
                'Hendelser opprettet i valgt periode, etter type. En gjentakende hendelse telles én gang. Svar teller nåværende Kommer- og Kommer ikke-svar.',
            byOrganization: 'Per organisasjon',
            organization: 'Organisasjon',
            unknownType: 'Ikke angitt',
            empty: 'Ingen organisasjoner samsvarer med filtrene.',
            empty_organization: 'Ingen tall for denne organisasjonen ennå.',
            deduplicationNote:
                'Brukertall er dagens tall. Meldinger gjelder valgt periode.',
            error: 'Kunne ikke laste statistikken. Prøv å oppdatere.',
            loading: 'Laster statistikk…',
            asOf: 'Oppdatert {{date}}',
        },
        dashboard: {
            newOrganization: 'Ny organisasjon',
            newAdmin: 'Ny administrator',
            sectionTitle: 'Administratorer',
        },
        notifications: {
            organizationCreated: 'Organisasjon opprettet.',
            organizationUpdated: 'Organisasjon oppdatert.',
            organizationDocumentsUpdated:
                'Organisasjonens dokumenter er oppdatert.',
            organizationDeleted: 'Organisasjon slettet.',
            adminCreated: 'Administrator opprettet.',
            adminDeleted: 'Administrator slettet.',
            adminPermissionsUpdated: 'Administratortilganger oppdatert.',
            genericError: 'Noe gikk galt.',
        },
        documents: {
            title: 'Dokumenter',
            description:
                'Last opp delte organisasjonsdokumenter for beboere, som velkomstinformasjon, kart eller praktiske guider.',
            folderNameLabel: 'Mappenavn',
            folderNamePlaceholder: 'Velkomstinfo',
            uploadButton: 'Last opp dokumenter',
            saveButton: 'Lagre dokumenter',
            removeButton: 'Fjern',
            previewButton: 'Forhåndsvis',
            previewLabel: 'Forhåndsvis {{name}}',
            previewClose: 'Lukk',
            previewDownload: 'Last ned',
            previewOpenTab: 'Åpne i ny fane',
            previewLoading: 'Laster dokument...',
            previewError: 'Kunne ikke laste dokumentet. Prøv igjen.',
            previewRetry: 'Prøv igjen',
            previewRenderError:
                'Nettleseren kunne ikke vise dokumentet. Åpne det i en ny fane eller last det ned.',
            previewPdfHint:
                'Hvis PDF-en ikke vises, åpne den i en ny fane eller last den ned.',
            previewUnsupported:
                'Forhåndsvisning er ikke tilgjengelig for denne filtypen. Last ned filen for å se innholdet.',
            empty: 'Ingen dokumenter er lastet opp ennå.',
            originalName: 'Opprinnelig fil',
            displayName: 'Visningsnavn',
            displayNamePlaceholder: 'Vises i appen',
            openedBy: 'Åpnet av',
            residentViews_one: '{{count}} beboer',
            residentViews_other: '{{count}} beboere',
            relativeViews_one: '{{count}} pårørende',
            relativeViews_other: '{{count}} pårørende',
            unsupportedType:
                'Kun PDF-, bilde- eller Office-dokumenter er tillatt.',
            fileTooLarge: 'Hvert dokument må være 10 MB eller mindre.',
            folderNameRequired:
                'Legg til et mappenavn før du lagrer dokumentene.',
        },
        forms: {
            createAdmin: {
                firstName: 'Fornavn*',
                lastName: 'Etternavn*',
                email: 'E-post*',
                initialPassword: 'Startpassord*',
                submit: 'Opprett administrator',
                supportPermission: 'Tillat skrivebeskyttet supporttilgang',
            },
            createOrganization: {
                organizationDetailsTitle: 'Organisasjonsdetaljer',
                administratorDetailsTitle: 'Første administrator',
                firstName: 'Fornavn*',
                lastName: 'Etternavn*',
                phone: 'Telefonnummer',
                email: 'E-post*',
                initialPassword: 'Startpassord*',
                shortName: 'Org. kortnavn*',
                displayName: 'Org. visningsnavn*',
                licences: 'Antall lisenser*',
                type: 'Organisasjonstype',
                typeCareHome: 'Seniorbolig',
                typeNursingHome: 'Sykehjem',
                disableLogoDesignAdjustments:
                    'Vis opplastet logo uten fargejusteringer',
                disableLogoDesignAdjustmentsHelper:
                    'Bruk dette for PNG-logoer som allerede har egne farger eller bakgrunn.',
                infoScreenEnabled: 'Aktiver infoskjerm',
                infoScreenEnabledHelper:
                    'Viser infoskjerm-siden for denne organisasjonen.',
                infoScreenModuleHistoryTitle: 'Historikk for infoskjerm',
                analyticsModuleEnabled: 'Aktiver analysemodul',
                analyticsModuleEnabledHelper:
                    'Gir organisasjonen sin egen analyse. Administratorer har alltid tilgang; andre ansatte kun som medlemmer av modulen.',
                analyticsModuleHistoryTitle: 'Analysemodul-historikk',
                appContentModuleEnabled: 'Aktiver dokumentmodul',
                appContentModuleEnabledHelper:
                    'Viser organisasjonens dokumenter til beboere og pårørende i Mundu-appen. Når den slås av, skjules dokumentene uten å slettes.',
                appContentModuleHistoryTitle: 'Dokumentmodul-historikk',
                calendarModuleEnabled: 'Aktiver kalendermodul',
                calendarModuleEnabledHelper:
                    'Gir denne organisasjonen tilgang til kalender- og hendelsesmodulen.',
                calendarModuleHistoryTitle: 'Kalendermodul-historikk',
                calendarModuleHistoryEnabled: 'Aktivert',
                calendarModuleHistoryDisabled: 'Deaktivert',
                submit: 'Opprett organisasjon',
                update: 'Oppdater organisasjon',
                groupsTitle: 'Grupper',
                groupsEmpty: 'Ingen grupper er definert ennå.',
                groupName: 'Gruppenavn',
                groupId: 'Gruppe-ID',
                groupLevelNameLabel: '{{levelName}} navn',
                addGroup: 'Legg til gruppe',
                removeGroup: 'Fjern gruppe',
                addGroupLevelNamed: 'Legg til {{levelName}}',
                removeGroupLevelNamed: 'Fjern {{levelName}}',
                rolesTitle: 'Roller',
                rolesEmpty: 'Ingen roller er definert ennå.',
                roleName: 'Rollenavn',
                roleId: 'Rolle-ID',
                roleGroups: 'Grupper',
                rolePermissions: 'Tilganger',
                rolePermissionsReadResidents: 'Les beboere',
                rolePermissionsWriteResidents: 'Skriv beboere',
                rolePermissionsReadEmployees: 'Les ansatte',
                rolePermissionsWriteEmployees: 'Skriv ansatte',
                rolePermissionsSendMessagesToAll: 'Send meldinger til alle',
                rolePermissionsEmpty: 'Ingen tilganger valgt ennå.',
                addRole: 'Legg til rolle',
                removeRole: 'Fjern rolle',
                hierarchyTitle: 'Gruppehierarki',
                hierarchyEmpty: 'Ingen hierarkinivåer lagt til ennå.',
                addHierarchyLevel: 'Legg til nivå',
                addHierarchySublevel: 'Legg til undernivå',
                removeHierarchyLevel: 'Fjern nivå',
                hierarchyLevelId: 'Nivå-ID',
                hierarchyLevelName: 'Navn på nivå',
            },
        },
        list: {
            deleteButton: 'Slett',
            addSupportPermission: 'Aktiver supporttilgang',
            removeSupportPermission: 'Deaktiver supporttilgang',
            fields: {
                name: 'Navn:',
                phone: 'Telefon:',
                email: 'E-post:',
                created: 'Opprettet:',
                updated: 'Oppdatert:',
            },
        },
        orgInfo: {
            memberLimitTitle: 'Medlemsgrense for modul',
            memberLimitHelper:
                'Maks antall ansatte organisasjonen kan legge til i denne modulen. {{count}} lagt til så langt. La stå tom for ingen grense.',
            memberLimitUnlimited: 'Ingen grense',
            memberLimitInvalid: 'Medlemsgrensen må være et positivt tall.',
            memberLimitBelowCurrent:
                'Grensen kan ikke være lavere enn gjeldende antall medlemmer ({{count}}). Be organisasjonsadministratoren fjerne medlemmer først.',
            fields: {
                superUser: 'Superbruker:',
                phone: 'Telefon:',
                email: 'E-post:',
                orgName: 'Org. kortnavn:',
                licences: 'Lisenser:',
                created: 'Opprettet:',
                updated: 'Oppdatert:',
            },
            editButton: 'Rediger organisasjon',
            enterSupportMode: 'Åpne supportmodus',
            enteringSupportMode: 'Åpner supportmodus…',
            deleteButton: 'Slett organisasjon',
        },
    },
    creators: {
        legacyAdmin: {
            title: 'Slette opprinnelig systemadministratorkonto?',
            deleteSectionTitle: 'Slett systemadministratorkonto',
            description:
                'Når du sletter {{name}}, blir denne innloggingen deaktivert og fjernet fra listene over ansatte og modulmedlemmer. Organisasjonsdata og historikk blir ikke endret.',
            readOnlyDescription:
                'Dette er organisasjonens opprinnelige systemadministratorkonto. Profilen kan ikke redigeres.',
            selfDeletion:
                'Logg inn med en annen systemadministratorkonto for å slette denne innloggingen.',
            confirmLabel: "Skriv inn '{{value}}' for å bekrefte",
            confirm: 'Slett systemadministratorkonto',
            success: 'Opprinnelig systemadministratorkonto er slettet.',
        },
        list: {
            roleNames: 'Rollenavn',
            department: 'Avdeling',
            missingReadEmployeesPermission:
                'Tilgang nektet: mangler rettighet til å lese ansatte.',
        },
        form: {
            firstName: 'Fornavn*',
            lastName: 'Etternavn*',
            phone: 'Telefonnummer',
            email: 'E-post',
            roleLabel: 'Rolle',
            departmentLabel: 'Avdeling (valgfritt)',
            employeeTypeLabel: 'Ansettelsestype',
            employeeTypeFullTime: 'Heltid',
            employeeTypePartTime: 'Deltid',
            noDepartment: 'Ingen avdeling',
            departmentHelp:
                'Brukes til statistikk om ansatte. Endrer ikke roller eller tilgang.',
            departmentLoadError:
                'Avdelingene kunne ikke lastes. Prøv igjen senere.',
            departmentLegacy: 'Tidligere avdelingsverdi: {{value}}',
            departmentLegacyHelp:
                'Denne gamle verdien er ikke en avdelingstilknytning. Velg en avdeling eller fjern verdien med Ingen avdeling.',
            departmentRemoved: 'Slettet avdeling',
            departmentRemovedHelp:
                'Den tidligere valgte gruppen er slettet. Dette regnes som Ingen avdeling. Velg en annen avdeling eller fjern tilknytningen.',
            departmentNestedHelp:
                'Denne gruppen er ikke lenger på øverste nivå. Tilknytningen beholdes, men gruppen kan ikke velges for nye tilknytninger.',
            rolePlaceholder: 'Velg rolle',
            rolesEmpty: 'Ingen roller er definert for denne organisasjonen.',
            roleRequired: 'Velg en rolle for å fortsette.',
            adminDescription:
                'Systemadministratorer har full tilgang til å administrere organisasjonen.',
            adminSelfRemoval:
                'Du kan ikke fjerne din egen tilgang som systemadministrator.',
            submit: 'Send invitasjon',
        },
        notifications: {
            consumerAdded: 'Bruker lagt til',
            consumerRemoved: 'Bruker fjernet',
            deleted: 'Ansatt slettet',
            created: 'Ansatt ble opprettet.',
        },
        profile: {
            editTitle: 'Rediger profil',
            deleteTitle: 'Slette ansatt?',
            deleteDescription:
                'Når en ansatt slettes mister vedkommende tilgang til Mundu og kan ikke gjenopprettes.',
            confirmLabel: "Skriv '{{value}}' for å slette",
            deleteButton: 'Slett ansatt',
        },
    },
    users: {
        leafGroups: {
            navLabel: 'Grupper',
            title: 'Gruppeliste',
            empty: 'Ingen grupper er tilgjengelige ennå.',
            parent: 'Overordnet',
            resident: 'Beboer',
            id: 'Gruppe-ID',
        },
        form: {
            firstName: 'Fornavn*',
            lastName: 'Etternavn*',
            password: 'Passord*',
            confirmPassword: 'Gjenta passordet*',
            username: 'Brukernavn*',
            submit: 'Opprett ny beboer',
            groupsLabel: 'Grupper',
            groupsPlaceholder: 'Velg grupper',
            groupsEmpty: 'Ingen grupper er tilgjengelige ennå.',
            groupsAvailableEmpty: 'Ingen tilgjengelige {{levelName}} ennå.',
            groupsTopLevelPlaceholder: 'Velg en hovedgruppe',
            groupsTopLevelPlaceholderNamed: 'Velg {{levelNames}}',
            groupsChildPlaceholder: 'Velg en undergruppe',
            groupsChildPlaceholderNamed: 'Velg {{levelName}}',
            groupsSelectedLeaf: 'Valgt gruppe: {{value}}',
        },
        limit: {
            title: 'Alle lisenser er i bruk!',
            description: 'Ønsker du flere lisenser?',
            contact: 'Kontakt oss',
        },
        profile: {
            editTitle: 'Rediger profil',
            password: 'Passord',
            passwordDescription:
                'Passordet til {{name}} vises nedenfor. Tilbakestill for å lage et nytt med en gang.',
            resetButton: 'Tilbakestill passord',
            resetInfo:
                'Del passordet på en trygg måte. Tilbakestill når du trenger et nytt.',
            passwordLabel: 'Passord:',
            passwordMissing: 'Ikke tilgjengelig',
            passwordResetSuccess: 'Passordet er oppdatert.',
            deleteTitle: 'Slette bruker?',
            deleteDescription:
                'Når en bruker slettes mister vedkommende tilgang til Mundu og det kan ikke angres.',
            confirmLabel: "Skriv '{{value}}' for å slette",
            deleteButton: 'Slett bruker',
            tabs: {
                images: 'Bildebibliotek',
                nextOfKin: 'Pårørende',
                messages: 'Meldinger',
                sessions: 'Videoer',
                profile: 'Profil',
            },
        },
        notifications: {
            created: 'Beboer ble opprettet.',
            deleted: '{{name}} er slettet.',
            creatorAdded: 'Ansatt lagt til',
            creatorRemoved: 'Ansatt fjernet',
        },
    },
    images: {
        actions: {
            add: 'Legg til bilder',
            discard: 'Forkast',
        },
        notifications: {
            deleted: 'Bilde slettet.',
        },
    },
    imageUpload: {
        dropzone: {
            add: 'Legg til bilder',
            discard: 'Forkast',
            invalidTypes:
                '{{count}} fil har et format som ikke støttes. Mundu støtter bare JPEG, JPG, PNG og WebP.',
            invalidTypes_plural:
                '{{count}} filer har formater som ikke støttes. Mundu støtter bare JPEG, JPG, PNG og WebP.',
            rejected: '{{count}} fil ble avvist.',
            rejected_plural: '{{count}} filer ble avvist.',
        },
        preview: {
            placeholder: 'Legg til en beskrivelse',
        },
        consent: {
            title: 'Samtykke',
            description:
                'Hos oss i Mundu tar vi personvern på alvor. Alle avbildede personer må samtykke, eller du må ha fullmakt til å samtykke på deres vegne, før bildene kan brukes i tjenesten. Les mer om Mundus personvernerklæring',
            readMore: 'her.',
            checkbox: 'Jeg samtykker',
            uploadLabel: 'Last opp {{count}} bilde',
            uploadLabel_plural: 'Last opp {{count}} bilder',
        },
    },
    sessions: {
        actions: {
            new: 'Ny video',
        },
        confirmDelete: 'Er du sikker på at du vil slette denne videoen?',
        notifications: {
            deleted: 'Video slettet.',
        },
    },
    login: {
        title: 'Logg inn',
        description:
            'Bruk e-post eller telefonnummer og passord for å logge inn i Mundu.',
        identifierLabel: 'E-post eller telefonnummer',
        passwordLabel: 'Passord',
        forgotPassword: 'Glemt passord?',
        submit: 'Logg inn',
        submitting: 'Logger inn…',
        genericError: 'Noe gikk galt. Prøv på nytt litt senere.',
        passwordChangeRequired:
            'Skriv inn et nytt passord for å aktivere kontoen før du logger inn.',
        newPasswordLabel: 'Nytt passord',
        confirmNewPasswordLabel: 'Bekreft nytt passord',
        newPasswordDescription:
            'Startpassordet virker bare én gang. Velg et nytt passord for å fortsette.',
        submitNewPassword: 'Lagre nytt passord',
        useDifferentAccount: 'Bruk en annen konto',
    },
    resetPassword: {
        title: 'Tilbakestill passord',
        description:
            'Be om en kode på e-post eller SMS og bruk den til å velge et nytt passord.',
        instructions:
            'Har du allerede en kode? Oppgi den sammen med e-postadressen eller telefonnummeret ditt for å sette et nytt passord.',
        request: {
            heading: 'Be om kode',
            emailLabel: 'E-post eller telefonnummer',
            submit: 'Send kode',
            success: 'Vi har sendt en bekreftelseskode til {{email}}.',
            genericError:
                'Vi klarte ikke å sende e-posten. Kontroller adressen og prøv igjen.',
        },
        reset: {
            heading: 'Sett nytt passord',
            codeLabel: 'Bekreftelseskode',
            newPasswordLabel: 'Nytt passord',
            confirmPasswordLabel: 'Bekreft passord',
            submit: 'Oppdater passord',
            success: 'Passordet er oppdatert. Du kan nå logge inn.',
            genericError:
                'Vi kunne ikke tilbakestille passordet. Kontroller koden og prøv igjen.',
            useDifferentEmail: 'Bruk en annen e-post',
        },
        backToLogin: 'Tilbake til innlogging',
    },
    notFound: {
        title: 'Denne siden finnes ikke!',
        goHome: 'Gå hjem',
        goToLanding: 'Gå til Mundu',
    },
    faq: faqNo,
};

export default noTranslations;
